import { render, staticRenderFns } from "./section-report-header-print.vue?vue&type=template&id=21ecfbf4&scoped=true"
import script from "./section-report-header-print.vue?vue&type=script&lang=js"
export * from "./section-report-header-print.vue?vue&type=script&lang=js"
import style0 from "./section-report-header-print.vue?vue&type=style&index=0&id=21ecfbf4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ecfbf4",
  null
  
)

export default component.exports